import { render, staticRenderFns } from "./SalesBasketLine.vue?vue&type=template&id=2983db89"
import script from "./SalesBasketLine.vue?vue&type=script&lang=js"
export * from "./SalesBasketLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports